export default __webpack_public_path__ + "static/media/i2.2137b6a8.jpg";